// src/ApiPanel/components/ApiPanelLayout.jsx
// Holds the two independent pieces of nav state:
//
//   collapsed   desktop rail narrowed to icons. Remembered per browser so it
//               survives a reload — a preference, not session state, so
//               localStorage is the right home for it and losing it is
//               harmless.
//   mobileOpen  off-canvas drawer. Always starts closed, and closes on
//               navigation and on resize back to desktop, so it can never be
//               left stuck open in a layout that has no way to dismiss it.
import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router";
import ApiPanelHeader from "./ApiPanelHeader";
import ApiPanelSidebar from "./ApiPanelSidebar";
import ApiPanelFooter from "./ApiPanelFooter";
import "../styles/apiPanel.css";

const COLLAPSE_KEY = "apiPanelNavCollapsed";

export default function ApiPanelLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(COLLAPSE_KEY) === "1";
    } catch {
      return false;
    }
  });
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    try {
      localStorage.setItem(COLLAPSE_KEY, collapsed ? "1" : "0");
    } catch {
      /* private mode — the preference just does not persist */
    }
  }, [collapsed]);

  useEffect(() => setMobileOpen(false), [pathname]);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 900) setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return (
    <div className="apip-shell">
      <ApiPanelSidebar
        collapsed={collapsed}
        mobileOpen={mobileOpen}
        onClose={() => setMobileOpen(false)}
        onExpandRail={() => setCollapsed(false)}
      />
      <div className="apip-main">
        <ApiPanelHeader
          onToggleSidebar={() => setCollapsed((v) => !v)}
          onOpenMobileNav={() => setMobileOpen(true)}
        />
        <div className="apip-content">
          <Outlet />
        </div>
        <ApiPanelFooter />
      </div>
    </div>
  );
}
